export const departmentsApiHandler = {
  getMyManagedDepartments: {
    method: "GET",
    path: () => `org-departments-management/my-managed-departments`
  },
  getDepartmentMembersProgress: {
    method: "GET",
    path: (payload: { departmentId: string | number }) => `org-departments-management/${payload.departmentId}/members-progress`
  }
};
